/**
 * ERROR PAGE
 *
 * @version 0.1
 */

import React from 'react';
import reduxStore from './../../reduxStore';
import { FormattedMessage } from 'react-intl';
import { hashHistory } from 'react-router';

import headerActions from './../../reusable/Header/Header.actions';
import popupActions from './../../reusable/MessagePopup/redux/MessagePopup.actions';

import Page404 from './templates/ErrorPage.404.jsx';
import Page403 from './templates/ErrorPage.403.jsx';
import Page500 from './templates/ErrorPage.500.jsx';
import Header from './../../reusable/Header/Header.index.jsx';
import Footer from './../../reusable/Footer/Footer.index.jsx';
import PageFailedLogin from './templates/ErrorPage.FailedLogin.jsx';

class ErrorPage extends React.Component {

    constructor(props) {
        super(props);
        this.goToHomePage = this.goToHomePage.bind(this);
    }

    componentWillMount() {

        if (reduxStore.getState().popupMessages.messages.length > 0) {
            this.messageId = reduxStore.getState().popupMessages.messages[0].titleId;
            this.msgId = reduxStore.getState().popupMessages.messages[0].messageId;
        } else {
            this.messageId = "500";
        }

        this.errorBody = null;

        switch (this.messageId) {
            case 'General_CoreFunctionality_Error_error.404Title':
                headerActions.updateHeader('errorPage404');
                this.errorBody = <Page404 />;
                break;

            case 'General_CoreFunctionality_Error_error.forbiddenTitle':
                headerActions.updateHeader('errorPage403');
                this.errorBody = <Page403 />;
                break;

            case 'General_CoreFunctionality_Error_error.FailedLoginTitle':
                headerActions.updateHeader('errorPageFailedLogin');
                this.errorBody = <PageFailedLogin msgId={this.msgId} />;
                break;

            default:
                headerActions.updateHeader('errorPage500');
                this.errorBody = <Page500 />;
        }

        // Prevent the popup from appearing due to the fact that the message remains in the stack.
        popupActions.clearMessages();
    }

    componentDidMount() {
        reduxStore.dispatch({type: 'REMOVE_ALL_SPINNERS'});
    }

    goToHomePage() {
        hashHistory.push("/start");
    }

    componentWillUnmount() {
        popupActions.clearMessages();
    }

    render() {

        return (
            <div className='app-wrapper'>
                <Header />
                <div className="error-page">
                    {this.errorBody}
                    <div className="error-page__navigation">
                        <button className="button-primary-lg"
                                onClick={this.goToHomePage}>
                            {
                                this.messageId === "General_CoreFunctionality_Error_error.FailedLoginTitle" ?
                                    <FormattedMessage id="General_CoreFunctionality_UIText_general.goToLogin" />
                                    :
                                    <FormattedMessage id="General_CoreFunctionality_UIText_general.goToHomepage" />
                            }

                        </button>
                    </div>
                </div>
                <Footer version={reduxStore.getState().header.version} />
            </div>
        );
    }

}

export default ErrorPage;



// WEBPACK FOOTER //
// ./src/scripts/pages/ErrorPage/ErrorPage.index.jsx